import React, { useEffect, useState } from 'react';
import { ApiService } from '../Services/apiServices';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';

const Header = () => {
    const [headermenu, setHeadermenu] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMenuData = async () => {
            try {
                const getMenuData = await ApiService.Commanfetchrequest('menu');
                setHeadermenu(getMenuData.headermenu || []);
                console.log('Menu data:', getMenuData);
            } catch (error) {
                console.log('Error in fetching menu data:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchMenuData();
    }, []);

    // Function to get subcategories by parent_id
    const getSubcategories = (parentId) => {
        return headermenu.filter((item) => item.parent_id === parentId);
    };

    // Mobile nav toggle function
    const mobileNavToggle = () => {
        document.body.classList.toggle('mobile-nav-active');
        const mobileNavToggleBtn = document.querySelector('.mobile-nav-toggle');
        mobileNavToggleBtn.classList.toggle('bi-list');
        mobileNavToggleBtn.classList.toggle('bi-x');
    };

    // Toggle dropdown
    const toggleDropdown = (e) => {
        e.preventDefault();
        const parentLi = e.target.closest('li');
        parentLi.classList.toggle('active');
        const dropdownMenu = parentLi.querySelector('.dropdown-menu');
        if (dropdownMenu) {
            dropdownMenu.classList.toggle('dropdown-active');
        }
    };

    return (
        <>
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
                    <Link to="/" className="logo d-flex align-items-center me-auto">
                        <h1 className="sitename">Sigo<span style={{ color: 'green' }}>Hrm</span></h1>
                    </Link>
                    <nav id="navmenu" className="navmenu">
                        <ul>
                            <li><Link to="/" className="active">Home</Link></li>

                            {loading ? (
                                // Skeletons for the menu items
                                Array.from({ length: 3 }).map((_, index) => (
                                    <li key={index}>
                                        <Skeleton height={20} width={60} />
                                    </li>
                                ))
                            ) : (
                                headermenu
                                    .filter((category) => category.parent_id === 0)
                                    .map((category) => {
                                        const subcategories = getSubcategories(category.id);

                                        return (
                                            <li key={category.id} className={subcategories.length > 0 ? 'dropdown' : ''}>
                                                <Link to={`/menu/${category.url}`} onClick={subcategories.length > 0 ? toggleDropdown : null}>
                                                    <span>{category.category_name}</span>
                                                    {subcategories.length > 0 && <i className="bi bi-chevron-down toggle-dropdown" />}
                                                </Link>

                                                {subcategories.length > 0 && (
                                                    <ul className="dropdown-menu">
                                                        <div className="dropdown-columns three-columns">
                                                            {[0, 1, 2].map((colIndex) => (
                                                                <div key={colIndex} className="dropdown-column">
                                                                    {subcategories
                                                                        .slice(colIndex * 3, colIndex * 3 + 3)
                                                                        .map((subcat) => (
                                                                            <li key={subcat.id}>
                                                                                <Link to={`/product/${subcat.url}`}>
                                                                                    <img
                                                                                        src={`https://sigohrmlpadmin.loopring.in/front/images/categories/${subcat.small_img}`}
                                                                                        alt="cate img"
                                                                                        style={{ width: 30, marginRight: 10 }}
                                                                                    />
                                                                                    {subcat.category_name}
                                                                                    {subcat.category_short_desc && (
                                                                                        <p className="short-desc d-none d-md-block">{subcat.category_short_desc}</p>
                                                                                    )}
                                                                                </Link>
                                                                            </li>
                                                                        ))}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </ul>
                                                )}
                                            </li>
                                        );
                                    })
                            )}

                            {loading ? (
                                <li><Skeleton height={20} width={70} /></li>
                            ) : (
                                <li><Link to="/login" target="_new" style={{ color: 'blue', fontWeight: 600, fontSize: 20 }}>Login</Link></li>
                            )}
                        </ul>

                        <i className="mobile-nav-toggle d-xl-none bi bi-list" onClick={mobileNavToggle} />
                    </nav>

                    {loading ? (
                        <>
                            <li style={{ listStyleType: 'none', paddingLeft: 10 }}>
                                <Skeleton height={30} width={120} />
                            </li>
                            <li style={{ listStyleType: 'none', paddingLeft: 10 }}>
                                <Skeleton height={30} width={120} />
                            </li>
                        </>
                    ) : (
                        <>
                            <li className="btn-wrapperrs d-none d-sm-block" style={{ listStyleType: 'none' }}>
                                <Link to="/start-free-trial" style={{ color: 'white', fontWeight: 600 }} className="btn-getstarted">
                                    Start Free Trial
                                </Link>
                            </li>
                            <li className="btn-wrapperrs d-none d-sm-block" style={{ listStyleType: 'none' }}>
                                <Link to="/book-demo" style={{ color: 'white', fontWeight: 600 }} className="btn-getstarted2">
                                    Book a Demo
                                </Link>
                            </li>
                        </>
                    )}
                </div>
            </header>
        </>
    );
};

export default Header;
